let currentSourceType = null

export const getCurrentSourceType = () => {
    return currentSourceType
}

export const setCurrentSourceType = (sourceType) => {
    currentSourceType = sourceType
}
